import styled, { css } from 'styled-components'

export const TextHomeContainer = styled.div<{
  isVisible: boolean
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  transform: translateY(100%);
  transition: transform 0.5s ease-in-out;
  margin-top: 100px;

  ${({ isVisible }) =>
    isVisible
      ? css`
          transform: translateY(0);
        `
      : css`
          transform: translateY(100%);
        `}
  .topics {
    display: flex;
    width: 100%;
    align-items: flex-start;
    max-width: 1170px;
    gap: 80px;

    .topic {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
  }

  @media (max-width: 791px) {
    .topics {
      align-items: flex-start;
      flex-direction: column;
      gap: 32px;
      .topic {
        gap: 8px;
      }
    }

    ${({ isVisible }) =>
      isVisible &&
      css`
        transform: translateY(-25%);
      `}
  }

  @media (max-height: 750px) {
    margin-top: 50px;
  }
`
